// React dependencies
import {
  Routes,
  Route,
  HashRouter
} from 'react-router-dom';

import Home from './pages/Home';
import Methodology from './pages/Methodology';
import About from './pages/About';
import Trends from './pages/Trends';

import { useEffect, useState } from "react";
import ReactGA from "react-ga4";

export default function App({}): JSX.Element {

    const [initialized, setInitialized] = useState(false);
  
    useEffect(() => {
        if (!window.location.href.includes("localhost")) {
            ReactGA.initialize("G-R3NLW6B20C");
        }
        ReactGA.send({ hitType: "pageview", page: "/", title: "Home" });
        setInitialized(true);
    }, []);

    return(
        <HashRouter>
            <Routes>
                <Route path="/" element={<Home initialized={initialized}/>} />
                <Route path="/Methodology" element={<Methodology initialized={initialized}/>} />
                <Route path="/About" element={<About initialized={initialized}/>} />
                <Route path="/Trends" element={<Trends initialized={initialized}/>} />
            </Routes>
        </HashRouter>
    );
}
